import { useIsDarkMode } from './useIsDarkMode';
import { getCustomTheme, type CustomThemeResult } from './getCustomTheme';

export const useCustomTheme = (
	backgroundColorRaw: string | null | undefined,
	highlightColorRaw: string | null | undefined,
): CustomThemeResult => {
	const isDarkMode = useIsDarkMode();
	return getCustomTheme({ backgroundColorRaw, highlightColorRaw, isDarkMode });
};
